import React, { Fragment } from 'react';

import StandardNotification from 'components/Notification/StandardNotification/StandardNotification';
import InlineNotification from 'components/Notification/InlineNotification/InlineNotification';
import ActionNotification from 'components/Notification/ActionNotification/ActionNotification';
import LinkWithinText from 'elements/Link/LinkWithinText/LinkWithinText';

import styles from './notificationsLayouts.css';

/* eslint-disable react/prop-types */
export const standardLayout = ({ layout, additionalMessage }) => (
  <StandardNotification title="New IP Request." additionalMessage={additionalMessage}>
    { layout === 'standard' ?
      'Your request to add was submitted.' :
      <Fragment>Lorem ipsum dolor sit amet, consectetur adipiscing elit <LinkWithinText size={'s'} medium>INFORMATION</LinkWithinText></Fragment>
    }
  </StandardNotification>
);


export const standardWithIconLayout = () => (
  <StandardNotification
    title="Informative Title"
    withIcon={{ name: 'bank-checkmark', type: '40' }}
  >
    Lorem ipsum dolor sit amet, cons ectetur adipiscing elit, sed do eius mod tempor sed do eius.
  </StandardNotification>
);

export const inlineLayout = () => (
  <div className={styles.inlineLayout}>
    <InlineNotification title="Informative Title">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
    </InlineNotification>
  </div>
);

export const actionLayout = () => (
  <div className={styles.actionLayout}>
    <ActionNotification
      highlightedTitle="Please Validate"
      title="your connections inventory"
      actionName="Validate"
      onActionClick={() => console.log('action notification callback')}
    >
      Expires on 13/12/2018
    </ActionNotification>
  </div>
);

/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/components/Notification/constants/notificationsLayouts.js